import { useFeatureFlag } from "configcat-react";
import { ReactElement, ReactNode } from "react";

import Construction from "@mui/icons-material/Construction";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";

import { getNsTrans } from "../../plugins/translations";
import sxStyles from "./Styles";

const Trans = getNsTrans("maintenancePage");

const Maintenance = () => {
    return (
        <Stack
            sx={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Paper sx={(theme) => sxStyles(theme).paper}>
                <Typography sx={(theme) => sxStyles(theme).title}>
                    <Trans>title</Trans>
                </Typography>
                <Box sx={(theme) => sxStyles(theme).icon}>
                    <SvgIcon fontSize="inherit">
                        <Construction />
                    </SvgIcon>
                </Box>
                <Typography sx={(theme) => sxStyles(theme).description}>
                    <Trans>description</Trans>
                </Typography>
            </Paper>
        </Stack>
    );
};

export const MaintenanceModeProvider = ({ children }: { children: ReactNode }): ReactElement => {
    const { value: maintenance } = useFeatureFlag("maintenance", false);

    if (maintenance) {
        return <Maintenance />;
    }

    return <>{children}</>;
};
